import { IEventV2 } from '@travelnest/typewriter';
import { IPostPayment } from 'data/entities/post-payment';
import React from 'react';
import { connect } from 'react-redux';
import { IPendingPostPayment } from '../../../../data/entities/post-payment/index';
import { queuePostPayment } from '../../../../entities/post-payment/actions';
import { IThunkDispatch } from '../../../../store/middleware';
import { IState } from '../../../../store/reducer';
import { ExceptionalPaymentsComponent } from './ExceptionalPayments';

interface IExceptionalPaymentsProps {
	event: IEventV2;
	pendingPayments: IPendingPostPayment[];
	deletePostPayments: (postPayments: IPostPayment[], eventId: string) => void;
}

const mapStateToProps = (state: IState) => ({
	pendingPayments: state.entities.pendingPostPayments.pendingPostPaymentData
});

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	deletePostPayments: (postPayments: IPostPayment[], eventId: string) => dispatch(queuePostPayment('remove', postPayments, eventId))
});

const ExceptionalPaymentsContainer: React.FC<IExceptionalPaymentsProps> = (props) => {
	const eventPendingPayments = props.pendingPayments.filter((payment) => payment.eventId === props.event.id);

	return <ExceptionalPaymentsComponent
		event={props.event}
		pendingPayments={eventPendingPayments}
		deletePostPayments={props.deletePostPayments}
	/>;
};

export const ExceptionalPayments = connect(mapStateToProps, mapDispatchToProps)(ExceptionalPaymentsContainer);
